import { Box, Container, Typography } from "@mui/material";

import { Subtitle1Text } from "components/shared/Typography";
import UploadTargetsBtn from "components/shared/UploadTargetsBtn";

export const TopBanner = () => (
  <Box
    component="section"
    position="relative"
    className="default-bg"
    pt={{ xs: 3, sm: 3, md: 4, lg: 7 }}
    pb={{ xs: 24.375, sm: 34.75, md: 24.25, lg: 27.875 }}
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap={{ xs: "18px", sm: 3, md: "30px" }}
      >
        <Typography variant="h1" align="center">
          <Box
            fontSize={{ xs: 22, sm: 64 }}
            lineHeight={{ xs: "28px", sm: "80px" }}
            letterSpacing={{ xs: 0.25, sm: 0.35 }}
          >
            Assay Marketplace
          </Box>
        </Typography>
        <Subtitle1Text align="center">
          Find the perfect catalog or custom panel that fits your needs.
        </Subtitle1Text>
        <UploadTargetsBtn size="large" />
      </Box>
    </Container>
  </Box>
);
